import React, {Component} from 'react';
import { connect } from 'react-redux';
import {getVerifyCode, verifyPhone,realUserMobileCaptcha} from '../../action/investmentAction.js';
import {userBindingMobile} from '../../action/loginAction.js';
import NavigatorMain from '../NavigatorMain';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';

let intervalId = null;
let requestId = "";

class VerifyDynamicCode extends Component{
  state = {
    mobileNumber: this.props.location.state ? this.props.location.state.mobileNumber : "",
    mobileDynamicCode: '',
    isRequestingVerifyCode: false,
    countdown: 120,
    flag: false
  }

  handleVerify = () => {
    if(requestId === '' || !requestId){
      Toast.info('请先申请手机验证码', 2);
      return ;
    }
    let verifyParam = {
      requestId : requestId,
      mobileNo : this.state.mobileNumber,
      captcha : this.state.mobileDynamicCode
    }
    this.setState({
      flag: true
    })
    this.props.dispatch(verifyPhone(verifyParam, ()=>{this.verifySuccess()}, (msg)=>this.verifyError(msg)));
  }


  verifySuccess = () => {
    this.setState({
      flag: false
    })
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    hashHistory.push({
      pathname: "/setNewPassword",
      state: {
        mobileNumber: this.state.mobileNumber,
        callback: callback,
        route: route
      }
    })
  }

  verifyError = (msg) => {
    this.setState({
      flag: false
    })
    Toast.info(msg, 2);
    // this.props.navigator.push({component: SetLoginPassword});  
  }

  handleWaitingForVerifyDynamicCode = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    let params = { mobileNo: this.state.mobileNumber }
    this.props.dispatch(realUserMobileCaptcha(params, (requestid)=>{requestId = requestid; }));
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(intervalId)
          clearInterval(intervalId);
        intervalId = null;
      }
    });
  }

  splitMobileNumber = (mobileNumber) => {
    if(this.props.isFromFast)
      return mobileNumber.substring(0,3)+' '+ '****' +' '+mobileNumber.substring(7);
    else
      return mobileNumber.substring(0,3)+' '+mobileNumber.substring(3,7)+' '+mobileNumber.substring(7);
  }

  componentWillUnmount(){
    requestId = '';
    this.setState({
      flag: false
    })
    if(intervalId)
      clearInterval(intervalId);
  }

  goBack = () => {
    hashHistory.goBack();
  }

  changeMobileDynamicCode = (event) => {
    this.setState({
      mobileDynamicCode: event.target.value
    });
  }

  componentWillMount() {
    document.title = "找回登录密码";
  }

  render(){
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>找回登录密码</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style = {{
            width: window.winWidth,
            height: 'auto'
          }}>
            <div style={{
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitJustifyContent: 'center',
              display: "-webkit-flex"
            }}>
              <span style={{
                marginTop: 50,
                fontSize: 22,
                color: '#3a3e47',
              }}>
                {this.splitMobileNumber(this.state.mobileNumber)}
              </span>
            </div>
            <div style={{
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitJustifyContent: 'center',
              display: "-webkit-flex"
            }}>
              <span style={{
                marginTop: 9,
                marginBottom: 10,
                color: '#5b6370',
                fontSize: 13,
              }}>
               （手机号）
              </span>
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>手机动态码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 10}}>
                <input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入短信验证码' value = {this.state.mobileDynamicCode} onChange = {this.changeMobileDynamicCode} />
              </div>
              {
                this.state.isRequestingVerifyCode ? 
                <div style = {{
                  backgroundColor: '#d8dbdd',
                  height: 27,
                  borderRadius: 13,
                  paddingLeft: 10,
                  paddingRight:10,
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex",
                  marginRight: 10,
                  width: 110
                }}>
                  <span style = {{color: "#5b6370", fontSize: 13}}>{this.state.countDown}秒后重发</span>
                </div>
                :
                <div style={{whiteSpace: "nowrap", width: 110, textAlign: "right", paddingRight: 13}}>
                  <span  onClick = {this.handleWaitingForVerifyDynamicCode} style = {{
                    color: '#fa063a',
                    fontSize: 13
                  }} >获取验证码</span>
                </div>
              }         
            </div>
          </div>
          <div  style = {{
            marginTop: 15,
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20
          }}  onClick = {this.state.mobileDynamicCode && this.state.mobileNumber ? this.handleVerify : null }>
            <div style = {{backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber ? '#fa063a' : '#afb0b2' ,WebkitAlignItems: 'center',WebkitJustifyContent: 'center',height: 40,borderRadius: 20,WebkitFlexDirection: 'row',display: "-webkit-flex"}}>
              <span style = {{color: '#ffffff', fontSize: 15}}>下一步</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(VerifyDynamicCode);


// WEBPACK FOOTER //
// ./src/components/login/VerifyDynamicCode.js